import type { KeyboardEvent as ReactKeyboardEvent } from 'react';

/** True on macOS and iOS, where the command key is the modifier. */
export const isMac: boolean =
  typeof navigator !== 'undefined' && /Mac|iPhone|iPad|iPod/.test(navigator.platform || navigator.userAgent);

/** True on touch-first devices (phones, tablets): offer the camera and the photo library. */
export function isCoarsePointer(): boolean {
  return typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia('(pointer: coarse)').matches;
}

/** The label of the primary modifier key: the command symbol on a Mac, Ctrl elsewhere. */
export const MOD_LABEL = isMac ? '\u2318' : 'Ctrl';

/** True when the event's primary modifier (Cmd on Mac, Ctrl elsewhere) is held. */
export function hasMod(e: KeyboardEvent | ReactKeyboardEvent): boolean {
  return isMac ? e.metaKey : e.ctrlKey;
}

/** True when keyboard focus is in a place that types text, so single-key shortcuts must not fire. */
export function isTypingTarget(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false;
  if (target.isContentEditable) return true;
  const tag = target.tagName;
  if (tag === 'TEXTAREA' || tag === 'SELECT') return true;
  if (tag === 'INPUT') {
    const type = (target as HTMLInputElement).type;
    return !['checkbox', 'radio', 'button', 'submit', 'reset', 'range', 'color'].includes(type);
  }
  return target.closest('[cmdk-root]') !== null;
}
